/**
 * Smoothly scrolls to the booking form (#booking) and focuses the first
 * focusable input. Measures the fixed navbar at runtime so the form clears
 * the header at any breakpoint.
 */
export const scrollToBooking = (
  options: { focus?: boolean; breathingRoom?: number } = {},
) => {
  const { focus = true, breathingRoom = 16 } = options;
  const el = document.getElementById("booking");
  if (!el) return;

  const nav = document.querySelector("nav");
  const navHeight = nav?.getBoundingClientRect().height ?? 0;
  const top =
    el.getBoundingClientRect().top + window.scrollY - navHeight - breathingRoom;

  window.scrollTo({ top, behavior: "smooth" });

  if (!focus) return;
  window.setTimeout(() => {
    const focusable = el.querySelector<HTMLElement>(
      'input:not([type="hidden"]):not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
    focusable?.focus({ preventScroll: true });
  }, 500);
};
